import { createSelector } from "reselect"
import { chain, isEmpty } from "lodash"
import { buildContributorKey } from "helpers/contributors"
import { computeExperiment } from "helpers/experiments"
import { getRebalancedContributors, getContributors } from "../contributors"
import { getWorkingEquity } from "../positions"
import { getRebalanceDate } from ".."

export const getExperiment = createSelector(
  [getRebalancedContributors, getContributors, getWorkingEquity, getRebalanceDate],
  (rebalancedPositions, originalPositions, equityOverride, rebalanceDate) => {
    let positions = originalPositions

    if (!isEmpty(rebalancedPositions)) {
      positions = rebalancedPositions
    }

    const heldPositions = chain(positions)
      .filter(({ notHeld }) => !notHeld)
      .keyBy(buildContributorKey)
      .value()
    return {
      type: "SIMULATION",
      equity: equityOverride,
      config: null,
      positionSet: {
        date: rebalanceDate,
        ...computeExperiment(heldPositions),
      },
    }
  },
)
